//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// components
import ValidationInvalidFeedback from '../common/ValidationInvalidFeedback.vue';
import ModalSendInformation from './ModalSendInformation.vue';

// util
import actionAjaxUrl from '../../../util/actionAjaxUrl.js';

// vendor
import {
    email,
    required,
} from 'vuelidate/lib/validators'

export default {
    name: 'PasswordReset',
    components: {
        ModalSendInformation,
        ValidationInvalidFeedback,
    },
    data: () => {
        return {
            pathAsset: '/app/themes/rits/dist/',
            passwordReset: {
                email: '',
            },
            responseSuccess: false,
            displayProcessingInformation: false,
        };
    },
    computed: {
    },
    validations() {
        let rules = {
            passwordReset: {
                email: {
                    required,
                    email,
                },
            },
        };

        return rules;
    },
    methods: {
        action: function () {
            this.$v.$touch();

            this.displayProcessingInformation = false;

            if (!this.$v.passwordReset.email.$error) {
                this.send();
            } else {
                this.responseSuccess = false;
                this.displayProcessingInformation = true;
            }
        },
        send: function () {
            const self = this;

            $.ajax({
                method: 'POST',
                data: {
                    email: self.passwordReset.email,
                },
                url: actionAjaxUrl('password_reset'),
            })
                .done(() => {
                    self.responseSuccess = true;
                })
                .fail(() => {
                    self.responseSuccess = false;
                })
                .always(() => {
                    self.displayProcessingInformation = true;
                })
        },
    },
    mounted () {
    },
}



// WEBPACK FOOTER //
// ./scripts/vue/components/common/PasswordReset.vue